<template>
	<div id="newsinfo" class="page">
		<div class="newscontent">
			<div class="title">
				{{newsinfo.subject}}
			</div>
			<div class="content" v-html="newsinfo.content"></div>
			<div class="bottom">
				<div>
					<i class="iconfont icon-comiischakanshu"></i>{{newsinfo.view}}
				</div>
				<div>
					<i class="iconfont icon-qianbao"></i>打赏：￥{{newsinfo.total_money}}
				</div>
			</div>
		</div>
		<button class='pay' v-if="showzs" v-on:click="event_ds" style="width:94%;position:fixed;bottom:3vw;left:3vw;width:94vw;border:0px;background-color:#ff7600;color:#FFFFFF;">赞赏</button>
	</div>
</template>

<script>
import { Toast } from 'we-vue'
export default {
  data () {
    return {
		loaded:false,
		newsinfo:{},
		showzs:false
	}
  },
  mounted () {

  },
  created(){
		this.showzs = this.$route.query.showzs
		this.$app.pr("/api/news/newsinfo",{
			id:this.$route.query.id
		}).then((res) => {
			this.newsinfo = res.data
			this.$app.pr('/api/common/jsparams',{
				url:this.$store.state.config.jtype ? this.$store.state.config.starturl : window.location.href,
				type:'news',
				id:this.newsinfo.id
			}).then((res) => {
				wx.config(res.data.shareparam);
				try{
					wx.ready(function(){
						wx.onMenuShareAppMessage({
							title:res.data.share_name,
							desc:res.data.share_desc,
							link:'https://jk.ioccn.com/newsinfo?id='+res.data.id+'&showzs='+res.data.user_id,
							imgUrl:res.data.share_image,
							success:function(){
							}
						});
						wx.onMenuShareTimeline({
							title: res.data.share_name,
							link: 'https://jk.ioccn.com/newsinfo?id='+res.data.id+'&showzs='+res.data.user_id,
							imgUrl: res.data.share_image
						});
					});
				}catch(e){alert('fx error'+e)}
			});
		});

		/*this.$app.pr('/api/common/jsparams',{
			url:window.location.href
		}).then((res) => {
			wx.config(res.data);
			try{
				alert(wx.updateAppMessageShareData)
				wx.updateAppMessageShareData({
					title:this.newsinfo.subject,
					desc:'',
					link:'https://jk.ioccn.com/newsinfo.php?id='+this.$route.query.id+'&showzs='+this.$store.state.userInfo.id
				});
			}catch(e){alert(e)}
		});*/
  },
  methods: {
	  event_ds(){
		this.$router.push({path:'/ds',query:{id:this.newsinfo.id,type:'news',to_user_id:this.showzs}});
	  }
  }
}
</script>

<style scoped>
	#newsinfo{
		background-color:#FFFFFF;
		min-height:100vh;
		max-width:100%;
		overflow:hidden;
	}
	.newscontent{
		padding:3vw;
	}
	.newscontent .title{
		font-size:5vw;
	}
	.newscontent .content{
		padding:3vw 0vw;
		border-top:1px solid #EEEEEE;
		margin-top:3vw;
	}
	.newscontent .content img{
		max-width:100%;
	}
	.newscontent .bottom{
		margin-top:50px;
		border-top:1px solid #EEEEEE;
		display:flex;
		display:-webkit-flex;
		line-height:13vw;
	}
	.newscontent .bottom div{
		flex:1;
		-webkit-flex:1;
		color:#a3a2a2;
		font-size:12px;
	}
	.newscontent .bottom div i{
		margin-right:10px;
	}
	.newscontent .bottom div:last-child{
		text-align:right;
	}
</style>



// WEBPACK FOOTER //
// src/components/Newsinfo.vue